// eslint-disable-next-line no-restricted-imports
import { BugIcon, CheckCircleIcon, InfoCircleIcon, showSnackbar } from '@glovo/uds-react'
import { useLocalisation } from '@/tools/i18n/client'

const TWO_SECONDS = 200000
export const useSnackbar = (timeout = TWO_SECONDS) => {
  const { t } = useLocalisation()
  const showError = (label: string) => {
    showSnackbar({
      closeButtonAriaLabel: t('common.close'),
      dismissible: true,
      leadingAccessory: <BugIcon />,
      label: label,
      timeout,
    })
  }

  const showSuccess = (label: string) => {
    showSnackbar({
      closeButtonAriaLabel: t('common.close'),
      dismissible: true,
      leadingAccessory: <CheckCircleIcon />,
      label: label,
      timeout,
    })
  }

  const showInfo = (label: string, { icon }: { icon?: React.ReactElement<unknown> } = {}) => {
    showSnackbar({
      closeButtonAriaLabel: t('common.close'),
      dismissible: true,
      leadingAccessory: icon || <InfoCircleIcon />,
      label: label,
      timeout,
    })
  }

  return { showError, showSuccess, showInfo }
}
